export default function InstallVueCallbacks(NetteAjax) {
  return NetteAjax.ext('vue-callbacks', {
    before: function (settings) {
      if (settings.nette && typeof settings.nette.ui.netteAjaxOnBefore === 'function') {
        settings.nette.ui.netteAjaxOnBefore(settings)
      
      } else if (settings.nette && typeof settings.nette.form?.netteAjaxOnBefore === 'function') {
        settings.nette.form.netteAjaxOnBefore(settings)
      }
    },
    success: function (payload, response, settings) {
      if (settings.nette && typeof settings.nette.ui.netteAjaxOnSuccess === 'function') {
        settings.nette.ui.netteAjaxOnSuccess(payload, response, settings)
      
      } else if (settings.nette && typeof settings.nette.form?.netteAjaxOnSuccess === 'function') {
        settings.nette.form.netteAjaxOnSuccess(payload, response, settings)
      }
    },
    error: function (error, settings) {
      if (settings.nette && typeof settings.nette.ui.netteAjaxOnError === 'function') {
        settings.nette.ui.netteAjaxOnError(error, settings)
      
      } else if (settings.nette && typeof settings.nette.form?.netteAjaxOnError === 'function') {
        settings.nette.form.netteAjaxOnError(error, settings)
      }
    }
  }, {
    install(Vue/*, context*/) {
      Vue.directive('ajax-on-before', (el, binding) => {
        if (typeof binding.value === 'function') {
          el.netteAjaxOnBefore = binding.value
        }
      })
      
      Vue.directive('ajax-on-success', (el, binding) => {
        if (typeof binding.value === 'function') {
          el.netteAjaxOnSuccess = binding.value
        }
      })
      
      Vue.directive('ajax-on-error', (el, binding) => {
        if (typeof binding.value === 'function') {
          el.netteAjaxOnError = binding.value
        }
      })
    },
  })
}
